<template>
  <div class="q-pa-md q-gutter-sm">
    <q-breadcrumbs>
      <q-breadcrumbs-el icon="home" to="/" />
      <q-breadcrumbs-el label="应付帐款" icon="payment" to="/payable" />
      <q-breadcrumbs-el
        label="应付帐款详情"
        icon="widgets"
        to="/payable/detail"
      />
    </q-breadcrumbs>
    <q-card>
      <q-tabs
        v-model="tab"
        dense
        class="text-grey"
        active-color="primary"
        indicator-color="primary"
        align="justify"
        narrow-indicator
      >
        <q-tab name="payable" label="应付帐款基本信息" />
        <q-tab name="detail" label="进项明细" v-if="payable.id" />
      </q-tabs>

      <q-separator />

      <q-tab-panels v-model="tab" animated>
        <q-tab-panel name="payable">
          <div class="q-col-gutter-y-lg">
            <div class="row justify-center">
              <div class="col-11" style="text-align: center">
                <h5>应付帐款信息</h5>
              </div>
            </div>
            <div class="row q-col-gutter-lg justify-center">
              <div class="col-11 col-md-3">
                <q-select
                  outlined
                  dense
                  v-model="payable.supplierId"
                  :options="supplierList"
                  option-label="supplierName"
                  option-value="id"
                  emit-value
                  map-options
                  label="供应商"
                  clearable
                >
                  <template v-slot:prepend>
                    <q-icon name="account_box" />
                  </template>
                </q-select>
              </div>
              <div class="col-11 col-md-3">
                <q-input
                  v-model="payable.total"
                  label="价税合计"
                  outlined
                  dense
                >
                  <template v-slot:prepend>
                    <q-icon name="money" />
                  </template>
                </q-input>
              </div>
              <div class="col-11 col-md-3">
                <q-input
                  v-model="payable.amountPaid"
                  label="已付金额"
                  clearable
                  outlined
                  dense
                >
                  <template v-slot:prepend>
                    <q-icon name="payment" />
                  </template>
                </q-input>
              </div>
            </div>
            <div class="row q-col-gutter-lg justify-center">
              <div class="col-11 col-md-3">
                <q-input
                  v-model="payable.amountBalance"
                  label="未付金额"
                  clearable
                  outlined
                  dense
                >
                  <template v-slot:prepend>
                    <q-icon name="account_balance_wallet" />
                  </template>
                  <template v-slot:append>
                    <q-btn
                      round
                      dense
                      flat
                      icon="calculate"
                      @click="calAmountBalance"
                    />
                  </template>
                </q-input>
              </div>
              <div class="col-11 col-md-3">
                <q-input
                  outlined
                  dense
                  v-model="payable.invoiceDate"
                  label="开票日期"
                  clearable
                >
                  <template v-slot:append>
                    <q-icon name="event" class="cursor-pointer">
                      <q-popup-proxy
                        ref="qDateProxy"
                        transition-show="scale"
                        transition-hide="scale"
                      >
                        <q-date v-model="payable.invoiceDate" mask="YYYY-MM-DD">
                          <div class="row items-center justify-end">
                            <q-btn
                              v-close-popup
                              label="Close"
                              color="primary"
                              flat
                            />
                          </div>
                        </q-date>
                      </q-popup-proxy>
                    </q-icon>
                  </template>
                </q-input>
              </div>
              <div class="col-11 col-md-3">
                <q-select
                  v-model="payable.status"
                  label="状态"
                  dense
                  clearable
                  outlined
                  emit-value
                  map-options
                  :options="options"
                >
                  <template v-slot:prepend>
                    <q-icon name="date_range" />
                  </template>
                </q-select>
              </div>
            </div>
            <div class="row q-col-gutter-lg justify-center">
              <div class="col-11 col-md-9">
                <q-input
                  v-model="payable.remark"
                  label="备注"
                  outlined
                  type="textarea"
                  clearable
                />
              </div>
            </div>
            <div class="row q-col-gutter-xl justify-center">
              <div class="col-11 q-gutter-x-md" style="text-align: center">
                <q-btn label="保存" color="primary" @click="save" />
                <q-btn flat label="取消" color="primary" @click="cancel" />
              </div>
            </div>
          </div>
        </q-tab-panel>

        <q-tab-panel name="detail">
          <q-table
            ref="mytable"
            title="进项明细"
            :data="payableItem.list"
            :columns="columns"
            row-key="id"
            :pagination.sync="pagination"
            :loading="loading"
            @request="request"
            binary-state-sort
            separator="cell"
            :rows-per-page-options="[10, 20, 50, 0]"
          >
            <template v-slot:body-cell-opt="props">
              <q-td>
                <div class="q-px-md q-gutter-sm" style="text-align: center">
                  <q-btn
                    round
                    color="primary"
                    size="xs"
                    icon="edit"
                    @click="handleEdit(props.rowIndex, props.row)"
                  />
                  <q-btn
                    round
                    color="deep-orange"
                    size="xs"
                    icon="delete_forever"
                    @click="handleRemove(props.row)"
                  />
                </div>
              </q-td>
            </template>
            <template v-slot:bottom-row>
              <q-tr v-if="payableItem.sumMap">
                <q-td align="center"> 合计 </q-td>
                <q-td align="center"> N/A </q-td>
                <q-td align="center">
                  {{
                    numbro(payableItem.sumMap.SUM_QUANTITY).format({
                      thousandSeparated: true,
                      mantissa: 2,
                    })
                  }}
                </q-td>
                <q-td align="center"> </q-td>
                <q-td align="center">
                  {{
                    numbro(payableItem.sumMap.SUM_TOTAL).format({
                      thousandSeparated: true,
                      mantissa: 2,
                    })
                  }}
                </q-td>
                <q-td align="center"> N/A </q-td>
              </q-tr>
            </template>
            <template v-slot:top="props">
              <div class="col-2 q-table__title">进项明细</div>
              <div class="col q-gutter-x-md">
                <q-btn dense icon="add" @click="visible = true;item.id=null" />
                <q-btn dense icon="download" />
              </div>
              <q-space />
              <q-btn
                flat
                round
                dense
                :icon="props.inFullscreen ? 'fullscreen_exit' : 'fullscreen'"
                @click="props.toggleFullscreen"
                class="q-ml-md"
              />
            </template>
          </q-table>

          <q-dialog v-model="visible">
            <q-card style="max-height: 80vh; width: 600px; max-width: 80vw">
              <q-card-section>
                <div class="text-h6">应付帐款明细</div>
              </q-card-section>

              <q-separator />

              <q-card-section class="scroll" style="max-height: 80vh">
                <div class="q-gutter-y-md column">
                  <q-input
                    v-model="item.itemName"
                    label="货物或应税劳务、服务名称"
                    clearable
                  >
                  </q-input>
                  <q-input v-model="item.spec" label="规格型号" clearable>
                  </q-input>
                  <q-input v-model="item.quantity" label="数量" clearable>
                  </q-input>
                  <q-input
                    v-model="item.unitPrice"
                    label="单价(含税)"
                    clearable
                  >
                  </q-input>
                  <q-input v-model="item.total" label="价税合计" clearable>
                    <template v-slot:append>
                      <q-btn
                        round
                        dense
                        flat
                        icon="calculate"
                        @click="calTotal"
                      />
                    </template>
                  </q-input>
                  <q-input
                    v-model="item.remark"
                    label="备注"
                    type="textarea"
                    clearable
                  >
                  </q-input>
                </div>
              </q-card-section>

              <q-separator />

              <q-card-actions align="right">
                <q-btn
                  flat
                  label="取消"
                  color="primary"
                  @click="visible = false"
                />
                <q-btn flat label="保存" color="primary" @click="saveItem" />
              </q-card-actions>
            </q-card>
          </q-dialog>
        </q-tab-panel>
      </q-tab-panels>
    </q-card>
  </div>
</template>

<script>
import { list as listSupplier } from "@/api/erp/supplier";
import {
  savePayableItem,
  removePayableItem,
  updatePayableItem,
  listPayableItem,
  detail,
  save,
  update,
} from "@/api/erp/finance/payable";
import numbro from "numbro";
export default {
  data() {
    return {
      numbro,
      tab: "payable",
      pagination: {
        sortBy: "desc",
        descending: false,
        page: 1,
        rowsPerPage: 10,
        rowsNumber: 0,
      },
      columns: [
        {
          name: "itemName",
          align: "center",
          label: "货物或应税劳务、服务名称",
          field: "itemName",
        },
        {
          name: "spec",
          align: "center",
          label: "规格型号",
          field: "spec",
        },
        {
          name: "quantity",
          align: "center",
          label: "数量",
          field: (row) =>
            numbro(row.quantity || 0).format({
              thousandSeparated: true,
              mantissa: 2,
            }),
        },
        {
          name: "unitPrice",
          align: "center",
          label: "单价(含税)",
          field: (row) =>
            numbro(row.unitPrice || 0).format({
              thousandSeparated: true,
              mantissa: 2,
            }),
        },
        {
          name: "total",
          align: "center",
          label: "价税合计",
          field: (row) =>
            numbro(row.total || 0).format({
              thousandSeparated: true,
              mantissa: 2,
            }),
        },
        {
          name: "opt",
          align: "center",
          label: "操作",
          field: "opt",
        },
      ],
      loading: false,
      options: [
        { value: "0", label: "未付款" },
        { value: "1", label: "部分付款" },
        { value: "2", label: "已结清" },
      ],
      supplierList: [],
      payable: { amountBalance: "" },
      payableItem: [],
      visible: false,
      item: {},
      queryForm: {},
    };
  },
  methods: {
    listSupplier() {
      var self = this;
      listSupplier().then((response) => {
        if (response.data.errorCode == "00000") {
          self.supplierList = response.data.data.list;
        }
      });
    },
    saveItem() {
      this.item.payableId = this.payable.id;
      var self = this;
      if (self.item.id) {
        updatePayableItem(self.item).then((response) => {
          if (response.data.errorCode == "00000") {
            self.$q.notify({ type: "positive", message: "更新成功" });
            self.visible = false;
            self.$refs.mytable.requestServerInteraction();
          } else {
            self.$q.notify({
              type: "negative",
              message: response.data.errorMsg,
            });
          }
        });
      } else {
        savePayableItem(self.item).then((response) => {
          if (response.data.errorCode == "00000") {
            self.$q.notify({ type: "positive", message: "保存成功" });
            self.visible = false;
            self.$refs.mytable.requestServerInteraction();
          } else {
            self.$q.notify({
              type: "negative",
              message: response.data.errorMsg,
            });
          }
        });
      }
    },
    save() {
      var self = this;
      if (self.payable.id) {
        update(self.payable).then((response) => {
          if (response.data.errorCode == "00000") {
            self.$q.notify({ type: "positive", message: "更新成功" });
          } else {
            self.$q.notify({
              type: "negative",
              message: response.data.errorMsg,
            });
          }
        });
      } else {
        save(self.payable).then((response) => {
          if (response.data.errorCode == "00000") {
            self.$q.notify({ type: "positive", message: "保存成功" });
            this.$router.push({
              path: "/payable/detail",
              query: { id: response.data.data },
            });
          } else {
            self.$q.notify({
              type: "negative",
              message: response.data.errorMsg,
            });
          }
        });
      }
    },
    cancel() {
      this.$router.push("/payable");
    },
    request(props) {
      this.loading = true;
      var self = this;
      const { page, rowsPerPage, sortBy, descending } = props.pagination;
      self.queryForm.pageNum = page;
      self.queryForm.pageSize = rowsPerPage;
      self.queryForm.payableId = self.payable.id;
      listPayableItem(self.queryForm).then(function (response) {
        if (response.data.errorCode == "00000") {
          self.payableItem = response.data.data;
          self.pagination.rowsNumber = self.payableItem.total;
          // don't forget to update local pagination object
          self.pagination.page = page;
          self.pagination.rowsPerPage = rowsPerPage;
          self.pagination.sortBy = sortBy;
          self.pagination.descending = descending;
          // ...and turn of loading indicator
          self.loading = false;
        } else {
          self.$message.error(response.data.errorMsg);
        }
      });
    },
    handleEdit(rowIndex, row) {
      this.item = JSON.parse(JSON.stringify(row));
      this.visible = true;
    },
    handleRemove(row) {
      var self = this;
      this.$q
        .dialog({
          title: "请谨慎操作",
          message: "此操作将永久删除该条记录, 是否继续?",
          cancel: "取消",
          ok: "确定",
          persistent: true,
        })
        .onOk(() => {
          console.log(">>>> OK");
          removePayableItem(row.id).then(function (response) {
            if (response.data.errorCode == "00000") {
              self.$q.notify({ type: "positive", message: "删除成功" });
              self.query();
            } else {
              self.$q.notify({
                type: "negative",
                message: response.data.errorMsg,
              });
            }
          });
        })
        .onCancel(() => {
          self.$q.notify({ type: "info", message: "已取消删除" });
        })
        .onDismiss(() => {
          console.log("I am triggered on both OK and Cancel");
        });
    },
    query() {
      this.$refs.mytable.requestServerInteraction();
    },
    calAmountBalance() {
      this.$set(
        this.payable,
        "amountBalance",
        this.payable.total - this.payable.amountPaid
      );
    },
    calTotal() {
      this.$set(this.item, "total", this.item.quantity * this.item.unitPrice);
    },
  },
  mounted() {
    this.listSupplier();

    let id = this.$route.query.id;
    var self = this;
    if (id) {
      detail(id).then((response) => {
        if (response.data.errorCode == "00000") {
          self.payable = response.data.data;
          self.request({ pagination: self.pagination });
        }
      });
    }
  },
};
</script>

<style scoped>
</style>